import React from 'react';
import Button from '../../common/primitives/Button';


import buttons from '../../common/primitives/Button.scss';
import styles from "./RegionMenu.scss";

import phoneImg from "./img/phone.png";
import bgFlagImg from "./img/bg.png";
import enFlagImg from "./img/en.png";
import arrowDownImg from "./img/arrow-down.png";
import {__t} from '../../common/lang/text-resource';


class RegionMenu extends React.Component {
	languagesVisible = false;

	componentDidMount() {
		document.addEventListener('mousedown', this.handleClickOutside);
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClickOutside);
	}

	static getLanguageFlag(lang) {

		if (lang === 'bg') {
			return bgFlagImg;
		} else {
			return enFlagImg;
		}
	}


	selectLanguage = lang => {
		this.props.changeLanguage(lang);
		this.languagesVisible = false;
		this.forceUpdate();
	};

	toggleLanguages = () => {
		this.languagesVisible = !this.languagesVisible;
		this.forceUpdate();
	};

	/**
	 * Set the wrapper ref
	 */
	setWrapperRef = node => {
		this.wrapperRef = node;
	};

	handleClickOutside = event => {
		if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
			if (this.languagesVisible) {
				this.languagesVisible = false;
				this.forceUpdate();
			}
		}
	};


	render() {
		const fullMenu =
		  <ul className={`${styles.regionMenu} ${(this.props.isMobile) ? styles.mobile : null}`}>
			  <li className={styles.phoneContainer}>
				  <img src={phoneImg} alt={__t("Phone")}/>
				  <a className={styles.phone} href={__t("tel:028108990")}>{__t('02 81 08 990')}</a>
			  </li>
			  <li className={(this.languagesVisible) ? styles.regionsVisible : styles.regionsHidden}>
				  <div className={`${styles.regionSwitch} `}>
					  <img
						src={RegionMenu.getLanguageFlag(this.props.currentLanguage.id)}
						alt={this.props.currentLanguage.name}/>

					  {
						  (this.props.isMobile && this.props.isMobileVisible) ? null :
							<img src={arrowDownImg} alt={__t("Show")} className={styles.regionsArrow}/>
					  }

					  <Button
						onClick={this.toggleLanguages}
						name={'show_regions'}
						value={this.props.currentLanguage.name}
						className={buttons.buttonLink}/>

				  </div>
				  {
					  (this.languagesVisible || !this.props.isMobile) ?
						<ul className={`${styles.regions}`} ref={this.setWrapperRef}>
							{
								this.props.allLanguages.map((region, key) => {
									return <li key={key}>

										<div>
											<img
											  src={RegionMenu.getLanguageFlag((this.props.isMobile) ? this.props.currentLanguage.id : region.id)}
											  alt={region.name}/>
											<Button
											  name={`${region.id}_change`}
											  onClick={() => this.selectLanguage(region.id)}
											  value={region.name}
											  className={buttons.buttonLink}/>
										</div>


									</li>
								})
							}
						</ul>
						: null
				  }
			  </li>
		  </ul>;


		if (this.props.isMobile && !this.props.isMobileVisible) {
			return null;
		}

		return fullMenu;
	}
}

export default RegionMenu;